import { SquareLock01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon, HugeiconsIconProps } from "@hugeicons/react";
import { Button, Paper, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material";

interface Props {
    icon?: HugeiconsIconProps['icon'];
    title?: string;
    description?: string;
}

const FeatureLock = ({
    icon = SquareLock01Icon,
    title = "Esta función está bloqueada",
    description = "Para desbloquearla, por favor actualiza tu suscripción"
}: Props) => {
    const { palette } = useTheme();

    return (
        <Paper>
            <Stack alignItems="center" spacing={2} padding={6}>
                <HugeiconsIcon icon={icon} size={46} strokeWidth={1} color={palette.primary.main} />
                <Stack spacing={0.5}>
                    <Typography variant="h3" align="center">
                        {title}
                    </Typography>
                    <Typography variant="body1" align="center">
                        {description}
                    </Typography>
                </Stack>
                <Button
                    variant="contained"
                    color="success"
                    onClick={() => {
                        window.open("https://wa.me/50587987846?text='Me gustaría actualizar mi cuenta'");
                    }}
                >
                    Actualizar Plan
                </Button>
            </Stack>
        </Paper>
    )
}

export default FeatureLock;
